import React from "react";
var __jsx = React.createElement;
import { motion } from 'framer-motion';
import { twMerge } from "tailwind-merge";
import { If } from "@componentsShared/Conditional/If";
export default function ProgressBar(_ref) {
  var _ref$progress = _ref.progress,
    progress = _ref$progress === void 0 ? 0 : _ref$progress,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 'h-4' : _ref$height,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'blue' : _ref$color,
    _ref$showLabel = _ref.showLabel,
    showLabel = _ref$showLabel === void 0 ? true : _ref$showLabel,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? 'Progress' : _ref$label,
    _ref$animate = _ref.animate,
    animate = _ref$animate === void 0 ? true : _ref$animate,
    _ref$rounded = _ref.rounded,
    rounded = _ref$rounded === void 0 ? 'rounded-full' : _ref$rounded,
    _ref$striped = _ref.striped,
    striped = _ref$striped === void 0 ? false : _ref$striped,
    _ref$glowing = _ref.glowing,
    glowing = _ref$glowing === void 0 ? false : _ref$glowing,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? 'classic' : _ref$style,
    _ref$background = _ref.background,
    background = _ref$background === void 0 ? "bg-gray-700/50" : _ref$background,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  var colorClasses = {
    blue: 'from-blue-500 to-blue-600',
    purple: 'from-purple-500 via-pink-500 to-red-500',
    green: 'from-green-500 to-emerald-600',
    orange: 'from-orange-500 to-red-600',
    cyan: 'from-cyan-400 to-cyan-500',
    yellow: 'from-yellow-400 to-amber-500',
    gradient: 'from-purple-500 via-pink-500 to-orange-500',
    primary: "from-primary to-primary-new bg-primary-new"
  };
  var getTransition = function getTransition() {
    switch (style) {
      case 'spring':
        return {
          type: "spring",
          stiffness: 100,
          damping: 15,
          mass: 0.5
        };
      case 'slow':
        return {
          duration: 1,
          ease: "easeInOut"
        };
      case 'fast':
        return {
          duration: 0.2,
          ease: "easeOut"
        };
      default:
        return {
          duration: 0.5,
          ease: "easeOut"
        };
    }
  };
  var glowStyle = glowing ? {
    boxShadow: '0 0 20px rgba(236, 72, 153, 0.6)'
  } : {};

  // Clamp progress between 0 and 100
  var clampedProgress = Math.max(0, Math.min(100, progress));
  return /*#__PURE__*/React.createElement("div", {
    className: twMerge("space-y-3", className)
  }, /*#__PURE__*/React.createElement(If, {
    condition: showLabel
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between text-sm font-medium text-gray-300"
  }, /*#__PURE__*/React.createElement("span", null, label), /*#__PURE__*/React.createElement(motion.span, {
    key: clampedProgress,
    initial: {
      scale: 1.2,
      opacity: 0
    },
    animate: {
      scale: 1,
      opacity: 1
    },
    transition: {
      duration: 0.2
    }
  }, clampedProgress, "%"))), /*#__PURE__*/React.createElement("div", {
    className: twMerge("overflow-hidden relative", height, rounded, background)
  }, /*#__PURE__*/React.createElement(motion.div, {
    className: twMerge("h-full bg-gradient-to-r", rounded, colorClasses[color]),
    style: glowStyle,
    initial: animate ? {
      width: 0
    } : {
      width: "".concat(clampedProgress, "%")
    },
    animate: {
      width: "".concat(clampedProgress, "%")
    },
    transition: getTransition()
  }, striped && /*#__PURE__*/React.createElement(motion.div, {
    className: "absolute inset-0 opacity-30",
    style: {
      backgroundImage: 'linear-gradient(45deg, transparent 25%, rgba(255,255,255,.4) 25%, rgba(255,255,255,.4) 50%, transparent 50%, transparent 75%, rgba(255,255,255,.4) 75%)',
      backgroundSize: '1rem 1rem'
    },
    animate: {
      x: ['0rem', '1rem']
    },
    transition: {
      duration: 1,
      repeat: Infinity,
      ease: "linear"
    }
  }))));
}